import { render } from "./EditInvoicePage.vue?vue&type=template&id=9b734b44&ts=true"
import script from "./EditInvoicePage.vue?vue&type=script&lang=ts"
export * from "./EditInvoicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__